"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactContentLoader = _interopRequireDefault(require("react-content-loader"));
var _utils = require("../../ResultsLoading/utils");
/* eslint-disable react/no-unknown-property */
var styles = {
  "item": "item_kLgGlS"
}; 
require('./VersionsLoading.css');
const CellLoader = ({
  min,
  max,
  height = 18
}) => {
  const width = (0, _utils.getRandomInteger)(min, max);
  return /*#__PURE__*/_react.default.createElement(_reactContentLoader.default, {
    height: height,
    viewBox: `0 0 ${max} 21`
  }, /*#__PURE__*/_react.default.createElement("rect", {
    x: 0,
    y: 0,
    rx: 3,
    ry: 3,
    width: width,
    height: 21
  }));
};
const Loading = props => {
  const statusCell = props.hideStatusCell ? null : /*#__PURE__*/_react.default.createElement(CellLoader, {
    key: "status",
    min: 60,
    max: 100,
    height: 23
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, [0, 1, 2, 3, 4].map(index => /*#__PURE__*/_react.default.createElement("li", {
    key: index,
    className: styles.item
  }, /*#__PURE__*/_react.default.createElement(CellLoader, {
    key: "version",
    min: 50,
    max: 60
  }), "\xA0", statusCell)));
};
var _default = exports.default = Loading;
//# sourceMappingURL=VersionsLoading.js.map